var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Box } from "@material-ui/core";
import FTLButton from "../buttons/FTLButton";
export default (_a) => {
    var { currentTabIndex, disabled, children, position = "sticky", onSaveMessage = "Сохранить", onCancel, onSave, onSaveBtnId, async, goToNextTab = () => { }, goToPrevTab = () => { }, BoxProps, showSaveButton = true } = _a, otherProps = __rest(_a, ["currentTabIndex", "disabled", "children", "position", "onSaveMessage", "onCancel", "onSave", "onSaveBtnId", "async", "goToNextTab", "goToPrevTab", "BoxProps", "showSaveButton"]);
    return (React.createElement(React.Fragment, null,
        position !== "static" && (React.createElement(Box, { mt: "auto", mb: 6, height: "56px", flexShrink: "0" })),
        React.createElement(Box, Object.assign({ mt: position === "static" ? 6 : undefined, display: "flex", justifyContent: "space-between", position: position, bottom: "0", width: "inherit", height: "56px", alignItems: "center", zIndex: 1, borderTop: "2px solid #E3E5E8", flexShrink: "0", style: {
                background: "#fff",
            } }, BoxProps, otherProps),
            React.createElement(Box, { display: "flex" },
                showSaveButton == true &&
                    React.createElement(FTLButton, { form: onSaveBtnId, async: async, type: "submit", color: "primary", disabled: disabled, onClick: (e) => {
                            if (onSave) {
                                e.preventDefault();
                                onSave();
                            }
                        }, style: {
                            flexShrink: 0,
                        } }, onSaveMessage),
                onCancel && (React.createElement(Box, { ml: 2, mr: 2, flexShrink: 0 },
                    React.createElement(FTLButton, { variant: "text", onClick: () => onCancel && onCancel() }, "\u041E\u0442\u043C\u0435\u043D\u0430"))),
                children),
            typeof currentTabIndex === "number" && (React.createElement(Box, { display: "flex" },
                React.createElement(FTLButton, { color: "secondary", onClick: goToPrevTab }, "\u041D\u0430\u0437\u0430\u0434"),
                React.createElement(Box, { ml: 2 },
                    React.createElement(FTLButton, { color: "secondary", onClick: goToNextTab }, "\u0414\u0430\u043B\u0435\u0435")))))));
};
//# sourceMappingURL=FTLToolbar.js.map